import React, { useState } from 'react';
import Switch from "react-bootstrap-switch";
import { CardBody,  Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { useForm } from "react-hook-form";
import { connect } from "react-redux";

import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";
import { setFilter } from "../../../redux/actions/generalActions/listActions";

const ContactFilters = props => {
    const { filter } = props.listProps
    const { app, udn } = props.mainProps

    const [status, setStatus] = useState(filter?.item?.status != null ? filter?.item?.status : null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
            code: filter?.item?.code || '',
            value: filter?.item?.value || ''
        }
    });

    const onSubmit = (data, _) => {
        if(!app?.fbDataBase?.id)
            return

        const dataFilter = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
                status : status,
                udn : { id : udn.id }
            }
        }

        if (status !== null)
            dataFilter.item.status = status;

        props.setFilter(dataFilter)
    };

    const cleanFields = () => {
        setStatus(null);
        setOnlyRegistered(true);
        reset();
    }

    return (<Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="2">
                    <FormGroup>
                        <Label>Codigo</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder="Búsqueda por código"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>Valor</Label>
                        <Input
                            type="text"
                            name="value"
                            placeholder="Búsqueda por valor"
                           innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>Activo</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            innerRef={register}
                            onChange={(item,val)=>setStatus(val)}
                        />
                    </FormGroup>
                </Col>
                <Col md="1">
                    <FormGroup>
                        <Label>Solo en app</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={onlyRegistered}
                            onChange={ () => setOnlyRegistered(!onlyRegistered) }
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>)
}

const mapStateToProps = state => ({
    listProps: state.listProps,
    mainProps: state.mainProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ContactFilters)